export default "__VITE_ASSET__CQD6wMaX__"